interface ValidationField {
  checkHtml5Validity(): boolean
}

const validationUtil = {
  checkFieldValidity(fields: ValidationField[]): boolean {
    const elements = fields
    const validationResults: boolean[] = []
    
    elements.forEach((element) => {
      validationResults.push(element.checkHtml5Validity())
    })
    
    const isValid = !validationResults.some((result) => !result)
    return isValid
  },
}

export default validationUtil